import React, { Component } from 'react';
import {apiService} from '../../common/apiCallService';
import Loading from '../Loading.js';
import {baseUrl} from '../../common/config.js';
import { Redirect } from 'react-router';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import validator from 'validator';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form'

var scrollToElement = require('scroll-to-element');
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService'

const validate = values => {
  // console.log("values+++++++++++",values)
  const errors = {}
  if (!values.first_name) {
    errors.first_name = 'First Name is Required'
  }

  if (!values.last_name) {
    errors.last_name = 'Last_name is Required'
  }

  if (!values.username) {
    errors.username = 'Username is Required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.username)) {
    errors.username = 'Invalid email address'
  }

  if (!values.password) {
    errors.password = 'Password is Required'
  } 

  if(!values.selectedRole) {
    errors.selectedRole='Select atleast a Role';
  }

  if(!values.mainBusiness) {
    errors.mainBusiness='Select atleast a Business';
  }

  if(values.selectedRole && (values.selectedRole.indexOf('SHIFT_MANAGER') ==! -1 || values.selectedRole.indexOf('COACH') ==! -1 || values.selectedRole.indexOf('PLAYER') ==! -1) && values.selectedRole.indexOf('BUSINESS_OWNER') === -1)
    if(!values.assignTo) {
      errors.assignTo='Select Assign To';
    }

  if(values.selectedRole && values.selectedRole.indexOf('PLAYER') ==! -1) {
    if(!values.selectedPlayerType) {
          errors.selectedPlayerType='Select Player Type';
        }
    if (!values.alias) {
          errors.alias = 'Enter Alias'
      } 
    if (!values.alias) {
      errors.accountName = 'Enter Account Name'
    }
  }

  return errors
}

class NewAppUser extends Component {

  constructor(props) {
    super(props)
    this.state = {
      usersList: [],
      loginRedirect: false,
      loading: false,
      first_name: '',
      last_name:'',
      username:'',
      mobile_no:'',
      email:'',
      _id:'',
      password:'',
      onSubmit: false,
      roles:[],
      selectedRole: '',
      title: '',
      mainBusiness: '',
      mainBussList: [],
      subBusiness: '',
      subBussList: [],
      assignToList: [],
      assignTo: '',
      playerType:[],
      selectedPlayerType:'',
      open:false,
      msg:'',
      roleFlag:true,
      access: JSON.parse(localStorage.getItem('userRole')),
      alias:'',
      accountName:'',
      playerId:'',
      status:0,
      userType:''
    }

    this.callApi = this.callApi.bind(this)
    this.updateUser = this.updateUser.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.saveUser = this.saveUser.bind(this)
    this.getRoles = this.getRoles.bind(this)
    this.getPlayerType = this.getPlayerType.bind(this)
    this.handleOpen=this.handleOpen.bind(this)
    this.handleClose=this.handleClose.bind(this)
    // this.getRoles()
    this.getPlayerType()
    this.getMainBusiness()

    if(props.match.params.id) {
      this.state._id = props.match.params.id
      this.state.title = 'Update User'
      // this.getMainBusiness()
      this.callApi();
    } else {
      this.state.title = 'New User'
    }

  }

  componentWillMount() {
    if(this.state.access.indexOf('SYS_ADMIN') !== -1 || this.state.access.indexOf('BUSINESS_OWNER') !== -1 || this.state.access.indexOf('SHIFT_MANAGER') !== -1 || this.state.access.indexOf('COACH') !== -1)
      return true
    else
      this.setState({loginRedirect: true})
  }

  componentDidMount() {
    createVirtualPageLoad("/newUser")
    setTimeout(() => {
      this.setState({password: ''})
      if(!this.state._id) this.setState({username: ''})
      // this.forceUpdate()
    },300)
  }

  componentWillUnmount() {
    closeVirtualPage()
  }

  callApi() {
    this.setState({loading: true})
      apiService(baseUrl + '/appUser/getUserDetails', {_id: this.state._id}, (data) => {
        // console.log("Data-------Data",data)
        this.setState({userType: data.userType})
          this.setState({first_name: data.first_name})
          this.setState({last_name: data.last_name})
          this.setState({username: data.username})
          this.setState({password: data.password})
          this.setState({mobile_no: data.mobile_no})
          this.setState({email: data.email})
        this.props.change('first_name', data.first_name)
        this.props.change('last_name', data.last_name)
        this.props.change('username', data.username)
        if (data.appRole.length>0) {
          var roleList = data.appRole.map((ob) => {return ob.authority})
          this.props.change('selectedRole', roleList)
          this.setState({selectedRole: roleList})
        }
        if (data.business.length>0) {
          this.props.change('mainBusiness', data.business.map(businessData => businessData))
          this.setState({mainBusiness: data.business})
        }
        if(data.business) {
          this.setState({assignTo:data.assigned_to})
          var roleData=[];
          roleData=data.appRole.map(role => role.authority)
          this.getAssignToMembers(roleData, data.business)
          this.props.change('assignTo', this.state.assignTo)
        }
        if (data.playerDetails.playerType.length>0) {
          this.props.change('selectedPlayerType', data.playerDetails.playerType[0])
        }
        if(data.playerDetails.alias){
          this.props.change('alias', data.playerDetails.alias)
        }
        if(data.playerDetails.accountName){
          this.props.change('accountName', data.playerDetails.accountName)
        }
        if(data.playerDetails) {
          this.setState({
            playerId: data.playerDetails._id,
            selectedPlayerType: data.playerDetails.playerType[0],
            alias: data.playerDetails.alias,
            accountName: data.playerDetails.accountName,
          })
        }
      })
  }

  updateUser() {
    this.setState({loading: true})
      apiService(baseUrl + '/appUser/updateUser', {
        "first_name": this.state.first_name,
        "last_name": this.state.last_name,
        "username": this.state.username,
        "mobile_no": this.state.mobile_no,
        "email": this.state.email,
        "selectedRole": this.state.selectedRole,
        "business": this.state.mainBusiness,
        "sub_business": this.state.sub_business,
        "assignTo": this.state.assignTo,
        "selectedPlayerType": this.state.selectedPlayerType,
        "alias": this.state.alias,
        "accountName": this.state.accountName,
        "status": 'Active',
        "_id": this.state._id,
        "playerId":this.state.playerId,
        "userType":this.state.userType
      }, (data) => {
          this.setState({open: true})
          this.setState({msg: data.msg,status:0})
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 406) {
            this.setState({msg: data.responseJSON.errorMsg, open: true,status:data.status})
          } else if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          } else this.setState({msg: "Something went wrong...Please try again",open: true,status:0})
      })
  }

  getRoles() {
    this.setState({loading: true})
      apiService(baseUrl + '/appUser/getRoles', {}, (data) => {
          this.setState({roles: data})
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  validateAndSave = (values) => {
    this.setState(
      { ...values },
      () => {
        if(this.state._id) this.updateUser()
        else {
          this.saveUser()
        }
      }
    );
  }

  saveUser() {
    if(!this.state.selectedRole)
      this.state.selectedRole = 'SHIFT_MANAGER'
    this.setState({loading: true})
      apiService(baseUrl + '/appUser/registerUser', {
          "first_name": this.state.first_name,
          "last_name": this.state.last_name,
          "username": this.state.username,
          "password": this.state.password,
          "mobile_no": this.state.mobile_no,
          "email": this.state.email,
          "selectedRole": this.state.selectedRole,
          "business": this.state.mainBusiness,
          "sub_business": this.state.sub_business,
          "assignTo": this.state.assignTo,
          "selectedPlayerType": this.state.selectedPlayerType,
          "alias": this.state.alias,
          "accountName": this.state.accountName,
          "status": 'Active'
      }, (data) => {
          this.setState({open: true})
          this.setState({msg: data.msg,status:0})
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 406) {
            this.setState({msg: data.responseJSON.errorMsg,open: true,status:data.status})
          } else if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          } else this.setState({msg: "Something went wrong...Please try again",open: true})
      })
  }

  getMainBusiness = () => {
    this.setState({loading: true})
      apiService(baseUrl + '/appUser/getRolesByAccess', {
        userRole: localStorage.getItem('userRole')
      }, (data) => {
        this.setState({loading: false})
        this.setState({mainBussList: data.buss})
        this.setState({roles: data.roles})
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  getAssignToMembers = (roles, buss) => {
    this.setState({loading: true})
    // console.log("----------roles--------",roles)
    // console.log("---------buss---------",buss)
      apiService(baseUrl + '/appUser/getUsersByParentRole', {
        "selectedRole": roles,
        "selectedBuss": buss
      }, (data) => {
        this.setState({loading: false})
        if(data.length > 0){
          this.setState({assignToList: data})
          if(this.state.assignTo){
            let arr = this.state.assignTo.filter((key)=>{
               return data.findIndex((obj) => {
                  return (obj._id === key)
                }) >= 0
             })
             this.setState({assignTo:arr})
          }
        }
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }


  onRoleChange = (value) => {
    console.log(value);
    if (value.indexOf('All') != -1) {
      this.getAssignToMembers(value, this.state.mainBusiness);
      this.setState({selectedRole: value});
      return this.props.roles.map(role => role._id);
    } else {
      this.getAssignToMembers(value, this.state.mainBusiness);
      this.setState({selectedRole: value});
      return value;
    }
  }

  getSubBusiness = (value) => {
    // console.log("value",value)
    if (value.indexOf('All') != -1) {
      var list = []
      list = this.state.mainBussList.map(function(id) {return id._id})
      this.setState({mainBusiness: list})
      this.getAssignToMembers(this.state.selectedRole, list)
      return this.state.mainBussList.map(business => business._id);
    } else {
      if(typeof value === 'string')
          value = [value]
      this.setState({mainBusiness: value})
      this.getAssignToMembers(this.state.selectedRole, value)
      return value;
    }
  }


  onAssignChange = (value) => {
    this.setState({assignTo: value});
    return value;
  }

  onPlayerTypeSelect = (value) => {
    // console.log("value",value)
    this.setState({selectedPlayerType: value})
    return value;
  }

  onCancel() {
    this.setState({onSubmit: true})
  }

  getPlayerType(){
    this.setState({loading: true})
      apiService(baseUrl + '/appUser/getPlayerType', {}, (data) => {
        this.setState({playerType: data})
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }
  
  handleOpen = () => {
     this.setState({open: true});
   };

  handleClose = () => {
     this.setState({open: false});
     if(this.state.status != 406)
     this.setState({onSubmit: true})
   };

  renderSelectField = (onChange) => ({ input, value, style, multiple, label, meta: { touched, error }, children, ...custom }) => {
    return (
      <SelectField
        floatingLabelText={label}
        value={value}
        style={style}
        errorText={touched && error}
        multiple={multiple}
        {...input}
        onChange={(event, index, value) => {
          input.onChange(onChange(value))
        }}
        children={children}
        {...custom}
      />
    )
  }

  renderTextField = ({ input, ref, value, style, label, type, meta: { touched, error }, ...custom }) => {
    return (
      <TextField
        hintText={label}
        floatingLabelText={label}
        ref={ref}
        style={style}
        type={type}
        value = {value}
        errorText={touched && error}
        {...input}
        {...custom}
      />
    )
  }

  render() {
    const { handleSubmit , submitting } = this.props;
    // console.log("roles",this.state.roles);
    this.props.setHeaderTitle(this.state.title)
    const actions = [
          <FlatButton
            label="Ok"
            primary={true}
            keyboardFocused={true}
            onClick={this.handleClose}
          />,
        ];
    const hideAutoFillColorStyle = {
        WebkitBoxShadow: '0 0 0 1000px #303030 inset'
    };
    return (
    <form onSubmit={handleSubmit(this.validateAndSave)}>
    <div>
        {this.state.loading
          ? <Loading/>
          : null}
      {this.state.loginRedirect && (
     <Redirect to={'/'}/>
         )}
       {this.state.onSubmit && (
                 <Redirect to={'/appUserComp'}/>
        )}
      <div className="container">
        <br/>
        <center>
            <Paper zDepth={5} className="resp-paper newAppUserPaper">
              <div>
                <Dialog
                  actions={actions}
                  modal={false}
                  open={this.state.open}
                  onRequestClose={this.handleClose}
                >
                {this.state.msg}
                </Dialog>
              </div>
              <center>
              <div className='container'>
              <div className="row" style={{marginLeft:'5px',marginRight: '5px',padding:'0'}}>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6" style={{padding:'0'}}>
                <Field data-e2e="selected-roles" name="selectedRole" value={this.state.selectedRole}  multiple={this.state.roleFlag} style={{textAlign: 'left'}} component={this.renderSelectField(this.onRoleChange)} label="Selected Roles">
                {this.state.roles.map((item, key) => {
                     return (<MenuItem insetChildren={true} checked={this.state.selectedRole && this.state.selectedRole.indexOf(item.authority) > -1} value={item.authority} primaryText={item.authority} />)
                   })}
                </Field>
                  <Field data-e2e="selected-business" name="mainBusiness" value={this.state.mainBusiness}  multiple={this.state.roleFlag} style={{textAlign: 'left'}} component={this.renderSelectField(this.getSubBusiness)} label="Selected Business">
                  <MenuItem value='All' primaryText='All' style={{marginLeft: '0px',padding: '0px', paddingLeft:'40px',position: 'relative'}}/>
                   {this.state.mainBussList.map((item, key) => {
                     return (<MenuItem insetChildren={true} checked={this.state.mainBusiness && this.state.mainBusiness.indexOf(item._id) > -1} value={item._id} primaryText={item.business_name} />)
                   })}
                </Field>
                 {this.state.selectedRole.indexOf('SYS_ADMIN') === -1 && this.state.selectedRole.indexOf('BUSINESS_OWNER') === -1
                   ?
                  <Field data-e2e="assignTo" name="assignTo" value={this.state.assignTo} multiple={this.state.roleFlag} style={{textAlign: 'left'}} component={this.renderSelectField(this.onAssignChange)} label="Selected AssignTo">
                  {this.state.assignToList.map((item, key) => {
                       return (<MenuItem value={item._id} primaryText={item.first_name + " " + item.last_name} checked={this.state.assignTo && this.state.assignTo.indexOf(item._id) > -1} />)
                     })}
                </Field>
                   : null}
                   {this.state.selectedRole.indexOf('PLAYER') != -1
                      ?<span>
                        <Field data-e2e="selectedPlayerType" name="selectedPlayerType" value={this.state.selectedPlayerType} style={{textAlign: 'left'}} component={this.renderSelectField(this.onPlayerTypeSelect)} label="Selected Player Type">
                           {this.state.playerType.map((item, key) => {
                             return (<MenuItem value={item._id} primaryText={item.player_Type} />)
                           })}
                        </Field>
                          <Field
                            data-e2e="alias"
                            name="alias"
                            ref="alias"
                            type="text"
                            value = {this.state.alias}
                            component={this.renderTextField}
                            label="Enter Alias"
                          />
                      </span>
                      :null}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6" style={{padding:'0'}}>
                <Field
                data-e2e="firstName"
                name="first_name"
                ref="first_name"
                type="text"
                value = {this.state.first_name}
                component={this.renderTextField}
                label="Enter First Name"
                />
                 <Field
                 data-e2e="lastName"
                name="last_name"
                ref="last_name"
                type="text"
                value = {this.state.last_name}
                component={this.renderTextField}
                label="Enter Last Name"
                />
                 {this.state.userType != 'PartyPoker'
                  ?
                  <Field
                  data-e2e="userName"
                  name="username"
                  ref="username"
                  type="text"
                  value = {this.state.username}
                  component={this.renderTextField}
                  style={hideAutoFillColorStyle}
                  label="Enter Username"
                  />
                  :null}
                  {this.state._id
                     ? null
                     :
                      <Field
                      data-e2e="password"
                      name="password"
                      ref="password"
                      type="password"
                      value = {this.state.password}
                      component={this.renderTextField}
                      style={hideAutoFillColorStyle}
                      label="Enter Password"
                      />
                      }
                       {this.state.selectedRole.indexOf('PLAYER') != -1 ?
                          <Field
                          data-e2e="accountName"
                          name="accountName"
                          ref="accountName"
                          type="text"
                          value = {this.state.accountName}
                          component={this.renderTextField}
                          label="Enter Account Name"
                        />
                          :null}
                </div>
              </div>
              </div>
              <div className="row" style={{marginLeft:'5px',marginRight: '5px',paddingTop:'30px',paddingLeft:'20px'}}>
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                  {this.state._id
                    ?<center>
                      {/* <RaisedButton label="UPDATE" primary={true} onClick={(event) => this.validate(event)}/> */}
                     <button  data-e2e="update" type="submit" disabled={submitting}>UPDATE</button>
                     </center>
                    :<center>
                      {/* <RaisedButton label="SUBMIT" primary={true} onClick={(event) => this.validate(event)}/> */}
                      <button data-e2e="submit" type="submit" disabled={submitting}>SUBMIT</button>
                      </center>}
                </div>
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                  <RaisedButton data-e2e="cancel" label="CANCEL" onClick={(event) => this.onCancel(event)}/>
                </div>
              </div>
              </center>
             </Paper>
           </center>

      </div>
    </div>
    </form>
    )
  }

}

NewAppUser = reduxForm({
  form: 'NewAppUserReduxForm',
  validate
})(NewAppUser)

const mapDispatchToProps = dispatch => {
  return {
    change: (field, value) => dispatch(change('NewAppUserReduxForm', field, value)),
    setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
  }
};

export default connect(null, mapDispatchToProps)(NewAppUser);



/** WEBPACK FOOTER **
 ** ./src/components/AppUser/NewAppUserReduxForm.js
 **/